import { Button } from 'primereact/button';
import './GridLayer.css';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

function GridLayer({ map }) {
  const { t } = useTranslation();
  const restoreElement = useRef();
  const [active, setActive] = useState(false);
  const [gridLayer, setGridLayer] = useState(
    map.getLayers().getArray()[map.getLayers().getArray().length - 1]
  );

  const handleClick = () => {
    gridLayer.setVisible(!gridLayer.getVisible());
    setActive(!active);
  };

  return (
    <div id="GridLayer" className="GridLayer">
      <Button
        className="HorizontalButton"
        type="button"
        alt={t('gridLayer.toggle')}
        title={t('gridLayer.toggle')}
        onClick={handleClick}
        ref={restoreElement}
        icon='pi pi-table'
      >
      
      </Button>
    </div>
  );
}

export default GridLayer;
